"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createContactByEmailReferenceResolver = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _createBatchedReferenceResolver = _interopRequireDefault(require("reference-resolvers/lib/createBatchedReferenceResolver"));

var _CacheKeys = _interopRequireDefault(require("reference-resolvers/constants/CacheKeys"));

var _ContactsAPI = require("reference-resolvers/api/ContactsAPI");

var createContactByEmailReferenceResolver = function createContactByEmailReferenceResolver(options) {
  return (0, _createBatchedReferenceResolver.default)((0, _extends2.default)({
    cacheKey: _CacheKeys.default.CONTACTS_BY_EMAIL,
    createFetchByIds: _ContactsAPI.createFetchContactByEmailAddress,
    fetchByIds: _ContactsAPI.fetchContactByEmailAddress
  }, options));
};

exports.createContactByEmailReferenceResolver = createContactByEmailReferenceResolver;

var _default = createContactByEmailReferenceResolver();

exports.default = _default;